<template>
  <div class="w-full flex items-center relative justify-center">
    <button v-if="!value" type="button" class="h-10 text-xl px-10 rounded-lg text-coral-400 border-2 border-coral-400 w-full" @click="browse">{{ __("Add media") }}</button>

    <div class="form-input p-0 flex flex-col max-w-104 max-h-full" :class="{ error: errors.length }">
      <input ref="file" type="file" accept="image/*,video/*" class="hidden" @change="change">

      <div class="flex-shrink-0 mx-auto">
        <img src="" alt="" ref="preview" class="mb-2" v-if="value">
        <div class="text-center break-all" v-if="value">{{ value.name }} <span class="text-grey-dark text-sm">({{ filesize(value.size) }})</span></div>
      </div>

      <div v-if="value" class="flex flex-col p-2 mt-2 items-center">
        <button type="button" class="btn-secondary outlined" @click="remove">{{ __("Cancel") }}</button>
      </div>
    </div>
    <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
  </div>
</template>

<script>
  import Icon from '@/Shared/Icon';

  export default {
    props: {
      loading: Boolean,
      value: File,
      errors: {
        type: Array,
        default: () => [],
      },
    },
    components: {Icon},
    watch: {
      value(value) {
        if (!value) {
          this.$refs.file.value = '';
          this.$refs.preview.src = '';
        }
      },
    },
    methods: {
      filesize(size) {
        let i = Math.floor(Math.log(size) / Math.log(1024));
        return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
      },
      browse() {
        this.$refs.file.click()
      },
      change(e) {
        let file = e.target.files[0];
        let reader = new FileReader();

        reader.onloadend = () => {
          this.$refs.preview.src = reader.result;
        };

        if (file) {
          reader.readAsDataURL(file);
        }

        this.$emit('input', e.target.files[0])
      },
      remove() {
        this.$emit('input', null)
      },
    },
  }
</script>
